Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Illustration2312599669",
  {"root":"Illustration2312599669--root","image":"Illustration2312599669--image"},
  "",
  1,
  "Illustration2312599669"
);
__webpack_require__.stylable.$.register(exports.default)
